/**
 * PWA Install Prompt
 * Maneja el evento beforeinstallprompt y muestra un banner de instalación personalizado
 */

let deferredPrompt: any;

/**
 * Muestra el banner de instalación si el usuario no lo ha ocultado
 */
function showInstallPromotion() {
    // Verificar si el usuario marcó "No volver a mostrar"
    if (localStorage.getItem('pwa-hide-install-prompt') === 'true') {
        console.log('🔕 Banner de instalación oculto por preferencia del usuario');
        return;
    }

    // Obtener nombre de la app desde variables de entorno
    const appName = process.env.VUE_APP_PWA_NAME || 'App';
    const appDesc = process.env.VUE_APP_PWA_DESCRIPTION || 'App Description';

    // Colores corporativos Laooal (ThemeConfig)
    const primary = '#4E6566';
    const accent  = '#9A9943';
    const textMain = '#3a4a4b';
    const textSub  = '#6F8586';

    // Crear banner de instalación con diseño moderno
    const installBanner = document.createElement('div');
    installBanner.id = 'pwa-install-banner';
    installBanner.innerHTML = `
    <div style="
      position: fixed;
      bottom: 24px;
      right: 24px;
      max-width: 380px;
      background: rgba(255, 255, 255, 0.98);
      backdrop-filter: blur(10px);
      border: 1px solid rgba(78, 101, 102, 0.15);
      padding: 20px;
      border-radius: 16px;
      box-shadow: 0 8px 32px rgba(78, 101, 102, 0.12), 0 2px 8px rgba(0, 0, 0, 0.04);
      z-index: 9999;
      display: flex;
      flex-direction: column;
      gap: 16px;
      animation: slideInUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    ">
      <div style="display: flex; align-items: flex-start; gap: 12px;">
        <div style="
          width: 48px;
          height: 48px;
          background: linear-gradient(135deg, ${primary} 0%, ${accent} 100%);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          box-shadow: 0 4px 12px rgba(78, 101, 102, 0.3);
        ">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="7 10 12 15 17 10"></polyline>
            <line x1="12" y1="15" x2="12" y2="3"></line>
          </svg>
        </div>
        <div style="flex: 1; min-width: 0;">
          <div style="
            font-size: 16px;
            font-weight: 600;
            color: ${textMain};
            margin-bottom: 4px;
            letter-spacing: -0.01em;
          ">Instalar ${appName}</div>
          <div style="
            font-size: 13px;
            color: ${textSub};
            line-height: 1.4;
          ">${appDesc}</div>
        </div>
        <button id="pwa-dismiss-btn" aria-label="Cerrar" style="
          background: transparent;
          border: none;
          width: 28px;
          height: 28px;
          border-radius: 6px;
          cursor: pointer;
          color: ${textSub};
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s;
          padding: 0;
          flex-shrink: 0;
        " onmouseover="this.style.background='rgba(78,101,102,0.08)'; this.style.color='${primary}';" onmouseout="this.style.background='transparent'; this.style.color='${textSub}';">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <label style="
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        font-size: 13px;
        color: ${textSub};
        user-select: none;
        padding: 4px 0;
      ">
        <input type="checkbox" id="pwa-hide-checkbox" style="
          width: 16px;
          height: 16px;
          cursor: pointer;
          accent-color: ${primary};
        ">
        <span>No volver a mostrar</span>
      </label>
      <button id="pwa-install-btn" style="
        background: linear-gradient(90deg, ${primary} 0%, ${accent} 100%);
        color: white;
        border: none;
        padding: 12px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        width: 100%;
        transition: all 0.2s;
        box-shadow: 0 2px 8px rgba(78, 101, 102, 0.25);
      " onmouseover="this.style.transform='translateY(-1px)'; this.style.boxShadow='0 4px 12px rgba(78, 101, 102, 0.4)';" onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 8px rgba(78, 101, 102, 0.25)';">
        Instalar App
      </button>
    </div>
    <style>
      @keyframes slideInUp {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      @media (max-width: 480px) {
        #pwa-install-banner > div {
          right: 16px !important;
          left: 16px !important;
          max-width: none !important;
        }
      }
    </style>
  `;

    document.body.appendChild(installBanner);

    // Botón de instalar
    const installBtn = document.getElementById('pwa-install-btn');
    if (installBtn) {
        installBtn.addEventListener('click', async () => {
            if (deferredPrompt) {
                deferredPrompt.prompt();
                const { outcome } = await deferredPrompt.userChoice;
                console.log(`Usuario ${outcome === 'accepted' ? 'aceptó' : 'rechazó'} instalar PWA`);
                deferredPrompt = null;
                const banner = document.getElementById('pwa-install-banner');
                if (banner) {
                    banner.remove();
                }
            }
        });
    }

    // Botón de cerrar
    const dismissBtn = document.getElementById('pwa-dismiss-btn');
    const hideCheckbox = document.getElementById('pwa-hide-checkbox') as HTMLInputElement;

    if (dismissBtn) {
        dismissBtn.addEventListener('click', () => {
            // Guardar preferencia si el checkbox está marcado
            if (hideCheckbox && hideCheckbox.checked) {
                localStorage.setItem('pwa-hide-install-prompt', 'true');
                console.log('✅ Preferencia guardada: No mostrar banner de instalación');
            }

            const banner = document.getElementById('pwa-install-banner');
            if (banner) {
                banner.remove();
            }
        });
    }
}

// Event listener para el prompt de instalación
window.addEventListener('beforeinstallprompt', (e) => {
    // Prevenir el prompt automático
    e.preventDefault();
    // Guardar el evento para usarlo después
    deferredPrompt = e;
    console.log('💡 PWA instalable detectada');

    // Mostrar botón de instalación
    showInstallPromotion();
});

// Detectar cuando la app fue instalada
window.addEventListener('appinstalled', () => {
    console.log('✅ PWA instalada exitosamente');
    deferredPrompt = null;
});
